@if (
  {
    enableHeader: enableHeader(),
    enableBody: enableBody(),
    enableFooter: enableFooter(),
    modalExtraClasses: modalExtraClasses(),
    enableClose: enableClose()
  };
  as STATE
) {
  <article class="custom-modal-card" [ngClass]="STATE.modalExtraClasses">
    @if (STATE.enableHeader) {
      <header class="custom-modal-card__header">
        <ng-content select="[header]"></ng-content>
        @if (STATE.enableClose) {
          <button
            type="button"
            class="close-button"
            mat-dialog-close
            [matTooltip]="'Fermer'"
            aria-label="Fermer"
          >
            <mat-icon svgIcon="dgi-cancel"></mat-icon>
          </button>
        }
      </header>
    }

    @if (STATE.enableBody) {
      <section class="custom-modal-card__body">
        <ng-content select="[body]"></ng-content>
      </section>
    }

    @if (STATE.enableFooter) {
      <footer #footer class="custom-modal-card__footer">
        <ng-content select="[footer]"></ng-content>
      </footer>
    }
  </article>
}
